<template>
    <div class="relative bg-indigo-600">
    <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div class="pr-16 sm:text-center sm:px-16">
            <p class="font-medium text-white">
                <span>
                    Vyzkoušejte si DSchránku 30 dní zdarma bez nutnosti zadávat platební údaje!
                </span>
                <span class="block sm:ml-2 sm:inline-block">
                    <a :href="route('register')" class="text-white font-bold underline"> Registrovat <span aria-hidden="true">&rarr;</span></a>
                </span>
            </p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "Trial",

}
</script>

<style scoped>

</style>
